import { createSlice } from '@reduxjs/toolkit';
import { BASE_URL_IMG, BASE_URL_IMG_LOGO } from '../utils/Constants';

const initialState = {
  userData: undefined,
  storeData: undefined,
  storeLogo: undefined,
  communityFlag: undefined,
  cgFlag: false,
  loginModal: false,
  userLocModal: false,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    changeUser: (state, action) => {
      const userData = action.payload;
      let cgFlag = userData?.seller?.username !== '';
      state.userData = userData;
      state.cgFlag = cgFlag;
    },
    changeStore: (state, action) => {
      const storeData = action.payload;
      let flag = false;
      let _logo = `${BASE_URL_IMG_LOGO}200/0/item/logo_bursakopi.png`;
      if (Object.keys(storeData ?? {}).length !== 0) {
        flag = storeData.is_community === 1;
        const flag_logo = storeData.logo !== '';
        _logo = flag_logo ? `${BASE_URL_IMG}100/100/${storeData.id}/${storeData.logo}` : '';
      }
      state.storeData = storeData;
      state.communityFlag = flag;
      state.storeLogo = _logo;
    },
    toggleLogin: (state, action) => {
      state.loginModal = action.payload;
    },
  },
});

export const { changeUser, changeStore, toggleLogin } = globalSlice.actions;
export default globalSlice.reducer;